import React from 'react';
import { useTranslation } from 'react-i18next';
import { useComplianceCountry } from '../../../../hooks/useComplianceCountry';
import { UaePensionPanel } from '../components/UaePensionPanel';
import { KsaGosiPanel } from '../components/KsaGosiPanel';
import {
  PensionCoverageView,
  GpssaRemittanceView,
  MonthlyPensionContributionView,
  GpssaComplianceSummaryView,
  GpssaContributionSkipView,
} from '../../../../models/payroll';

interface PensionTabProps {
  year: number;
  month: number;
  coverage: PensionCoverageView[];
  remittance: GpssaRemittanceView | null;
  contributions: MonthlyPensionContributionView[];
  summary: GpssaComplianceSummaryView | null;
  /** True when exactly one CompanyGrossPay component is flagged IsBasicSalary. */
  basicSalaryHealthy?: boolean;
  /** Count of components flagged IsBasicSalary (0 = missing, >1 = ambiguous). */
  basicSalaryConfigCount?: number;
  /** CO-256 — skip reasons owned by the page so a re-fetch cannot unmount them. */
  skipped: GpssaContributionSkipView[];
  onSkipped: (items: GpssaContributionSkipView[]) => void;
  onContributionsGenerated: (items: MonthlyPensionContributionView[]) => void;
  onError: (msg: string) => void;
  onInfo?: (msg: string) => void;
}

export const PensionTab: React.FC<PensionTabProps> = (props) => {
  const { t } = useTranslation();
  const country = useComplianceCountry();

  if (country === 'UAE') {
    return <UaePensionPanel {...props} />;
  }

  if (country === 'KSA') {
    return (
      <KsaGosiPanel
        year={props.year}
        month={props.month}
        onError={props.onError}
      />
    );
  }

  return (
    <div className="p-5 text-sm text-muted-foreground">
      {t('payroll.complianceCenter.noComplianceCountry', 'No compliance country configured for this company.')}
    </div>
  );
};
